export default {
  API_PREFIX: '/status',
};
